"use strict";

(function($){

    window.showHeaderSearchFormLoadInd = function(cb) {

        // hide search form
        var $block = $('#header_booking_form_block');
        $('._title',                  $block).hide();
        $('._subtitle',               $block).hide();
        $('._booking_option_details', $block).hide();
        $('._search_form',            $block).hide();
        $('._info_text',              $block).hide();
        $('._co2_neutral_btn',        $block).hide();

        // scroll to top
        $("html, body").animate({ scrollTop: 0 }, 350);

        // show loading indicator
        $('#header_search_form_load_ind').fadeIn(400, cb);
    };

    window.submitHeaderSearchForm = function() {
        $('#header_search_form')[0].submit();
    };

    window.validateHeaderSearchForm = function() {

        var $form = $('#header_search_form');
        var is_invalid = false;

        // reset err indicators
        $('._select2_container', $form).each(function() {
            $(this).removeClass('_select2_container_err');
        });

        $('._input_container', $form).each(function() {
            $(this).removeClass('_input_container_err');
        });

        var $fly_from = $('#filter_fly_from', $form);
        if (!$fly_from.val()) {
            $fly_from.parent().addClass('_select2_container_err');
            is_invalid = true;
        }

        var $fly_to = $('#filter_fly_to', $form);
        if (!$fly_to.val()) {
            $fly_to.parent().addClass('_select2_container_err');
            is_invalid = true;
        }

        var flight_type = $('#header_search_form_flight_type option:selected', $form).val();

        var $date_fr_dmy = $('#flights_date_fr_dmy', $form);
        if (!$date_fr_dmy.val()) {
            $date_fr_dmy.parent().addClass('_input_container_err');
            is_invalid = true;
        }

        var $date_to_dmy = $('#flights_date_to_dmy', $form);
        if (
            flight_type === 'round'
            && !$date_to_dmy.val()
            && $date_to_dmy.attr('placeholder') !== $date_to_dmy.attr('data-placeholder-round-anytime')
            && !window.siteData.search_return_anytime_enabled
        ) {
            $date_to_dmy.parent().addClass('_input_container_err');
            is_invalid = true;
        }

        if (is_invalid) {
            return false;
        }

        window.showHeaderSearchFormLoadInd(window.submitHeaderSearchForm);
        return false; // prevent form submission before load ind
    };

    window.updateActiveFiltersStat = function() {
        var $stat_active_filters = $('#stat_nr_active_filters');
        if ($stat_active_filters.length) {

            // we have to count by display = block as :visible pseudo selector
            // is not counted when the whole menu is closed
            var nr_active_filters = 0;
            $('._fr_filter_clear_btn').each(function() {
                if ($(this).css('display') === 'block') {
                    nr_active_filters ++;
                }
            });

            if (nr_active_filters) {
                $stat_active_filters.text(nr_active_filters).css('display', 'inline-block');
            } else {
                $stat_active_filters.hide();
            }
        }
    };

    window.initLeftFilters = function() {

        // region Providers
        (function() {
            $('#fr_filter_providers_container input[type="checkbox"]').each(function() {
                $(this).click(function() {
                    window.toggleLeftFiltersProvidersClearBtn();
                    window.updateFlightsSearchResults();
                });
            });
        })();

        window.toggleLeftFiltersProvidersClearBtn = function() {
            var $clear_btn  = $('#fr_filter_providers_clear_btn');
            if (!$clear_btn.length) return false;

            var is_used = false;

            $('#fr_filter_providers_container input').each(function() {
                if (!$(this).prop('checked')) {
                    is_used = true;
                    return false; // break
                }
            });

            if (is_used) {
                $clear_btn.show();
            } else {
                $clear_btn.hide();
            }
        };

        window.clearLeftFiltersProviders = function() {
            $('#fr_filter_providers_container input').each(function() {
                $(this).prop('checked', true);
            });
        };
        // endregion


        // region Stops : Toggle Clear Btn
        window.toggleLeftFiltersStopsClearBtn = function() {
            var $clear_btn  = $('#fr_filter_stops_clear_btn');
            if (!$clear_btn.length) return false;

            var $f_stops = $('#left_stops_section input[name="fr_filter_stops"]:checked');
            if ($f_stops.length && $f_stops.val() !== "-1") {
                $clear_btn.show();
                return false;
            }

            var $f_allow_overnight_stopovers = $('#left_stops_section #fr_filter_stops_allow_overnight');
            if ($f_allow_overnight_stopovers.length && !$f_allow_overnight_stopovers.prop('checked')) {
                $clear_btn.show();
                return false;
            }

            $clear_btn.hide();
        };
        // endregion

        // region Stops : Updated (onclick)
        window.leftFiltersStopsUpdated = function() {
            window.toggleLeftFiltersStopsClearBtn();
            window.updateFlightsSearchResults();
        };
        // endregion

        // region Stops : Clear
        window.clearLeftFiltersStops = function() {
            $('#left_stops_section input[name="fr_filter_stops"][value="-1"]').prop("checked", true);
            $('#left_stops_section #fr_filter_stops_allow_overnight').prop('checked', true);
        };
        // endregion


        // region Duration : Toggle Clear Btn
        window.toggleLeftFiltersDurationClearBtn = function() {
            var $clear_btn  = $('#fr_filter_duration_clear_btn');
            if (!$clear_btn.length) return false;

            if (typeof window.leftFiltersDurationMaxTravelTime !== "undefined") {
                var f1_slider_max = Math.round(window.leftFiltersDurationMaxTravelTime.attr('data-slider-max'));
                var f1_slider_val = Math.round(window.leftFiltersDurationMaxTravelTime.slider('getValue'));
                if (f1_slider_val < f1_slider_max) {
                    $clear_btn.show();
                    return false;
                }
            }

            if (typeof window.leftFiltersDurationStopover !== "undefined") {
                var f2_slider_min = Math.round(window.leftFiltersDurationStopover.attr('data-slider-min'));
                var f2_slider_max = Math.round(window.leftFiltersDurationStopover.attr('data-slider-max'));
                var f2_values     = window.leftFiltersDurationStopover.slider('getValue');
                var f2_value_min  = Math.round(f2_values[0]);
                var f2_value_max  = Math.round(f2_values[1]);

                if (f2_value_min > f2_slider_min || f2_value_max < f2_slider_max) {
                    $clear_btn.show();
                    return false;
                }
            }

            $clear_btn.hide();
        };
        // endregion

        // region Duration : Max travel time
        (function() {
            var $input = $('#fr_filter_duration_max_travel_time');
            if (!$input.length) return false;

            var $label         = $('#fr_filter_duration_max_travel_time_label');
            var label_prefix   = $input.attr('data-label-prefix');
            var label_hour     = $input.attr('data-label-hour');
            var label_hours    = $input.attr('data-label-hours');
            var label_default  = $input.attr('data-label-default');
            var slider_max     = Math.round($input.attr('data-slider-max'));

            window.leftFiltersDurationMaxTravelTime = $input.slider({
                tooltip: 'hide',
                step: 0.1
            });

            window.leftFiltersDurationMaxTravelTime
                .on('slide', function () {
                    var value = Math.round(window.leftFiltersDurationMaxTravelTime.slider('getValue'));
                    if (value === slider_max) {
                        $label.text(label_default);
                    } else {
                        $label.text(label_prefix + ' ' + value + ' ' + (value !== 1 ? label_hours : label_hour));
                    }
                })
                .on('slideStop', function () {
                    window.leftFiltersDurationMaxTravelTime.trigger('slide');
                    window.toggleLeftFiltersDurationClearBtn();
                    window.updateFlightsSearchResults();
                }).trigger('slide');

            window.clearLeftFiltersDurationMaxTravelTime = function() {
                window.leftFiltersDurationMaxTravelTime.slider('setValue', slider_max, true, false);
            };

        })();
        // endregion

        // region Duration : Min-Max Stopover
        (function() {
            var $input = $('#fr_filter_duration_stopover');
            if (!$input.length) return false;

            var $label      = $('#fr_filter_duration_stopover_label');
            var label_hours = $input.attr('data-label-hours');
            var slider_min  = Math.round($input.attr('data-slider-min'));
            var slider_max  = Math.round($input.attr('data-slider-max'));

            window.leftFiltersDurationStopover = $input.slider({
                tooltip: 'hide',
                step: 0.1
            });

            window.leftFiltersDurationStopover
                .on('slide', function () {
                    var values    = window.leftFiltersDurationStopover.slider('getValue');
                    var value_min = Math.round(values[0]);
                    var value_max = Math.round(values[1]);

                    $label.text(value_min + ' - ' + value_max + ' ' + label_hours);
                })
                .on('slideStop', function () {
                    window.leftFiltersDurationStopover.trigger('slide');
                    window.toggleLeftFiltersDurationClearBtn();
                    window.updateFlightsSearchResults();
                }).trigger('slide');

            window.clearLeftFiltersDurationStopover = function() {
                window.leftFiltersDurationStopover.slider('setValue', [slider_min, slider_max], true, false);
            };

        })();
        // endregion


        // region Co2 : Toggle Clear Btn
        window.toggleLeftFiltersCo2ClearBtn = function() {
            var $clear_btn  = $('#fr_filter_co2_clear_btn');
            if (!$clear_btn.length) return false;

            if (typeof window.leftFiltersCo2 !== "undefined") {
                var slider_min = Math.round(window.leftFiltersCo2.attr('data-slider-min'));
                var slider_max = Math.round(window.leftFiltersCo2.attr('data-slider-max'));
                var values     = window.leftFiltersCo2.slider('getValue');
                var value_min  = Math.round(values[0]);
                var value_max  = Math.round(values[1]);

                if (value_min > slider_min || value_max < slider_max) {
                    $clear_btn.show();
                    return false;
                }
            }

            $clear_btn.hide();
        };
        // endregion

        // region Co2 : Min-Max
        (function() {
            var $input = $('#fr_filter_co2');
            if (!$input.length) return false;

            var $label                = $('#fr_filter_co2_label');
            var label_default         = $input.attr('data-label-default');
            var slider_min            = Math.round($input.attr('data-slider-min'));
            var slider_max            = Math.round($input.attr('data-slider-max'));

            window.leftFiltersCo2 = $input.slider({
                tooltip: 'hide',
                step: 0.1
            });

            window.leftFiltersCo2
                .on('slide', function () {
                    var values    = window.leftFiltersCo2.slider('getValue');
                    var value_min = Math.round(values[0]);
                    var value_max = Math.round(values[1]);

                    if (value_min === slider_min && value_max === slider_max) {
                        $label.text(label_default);
                    } else {
                        $label.text(value_min + ' kg - ' + value_max + ' kg');
                    }
                })
                .on('slideStop', function () {
                    window.leftFiltersCo2.trigger('slide');
                    window.toggleLeftFiltersCo2ClearBtn();
                    window.updateFlightsSearchResults();
                }).trigger('slide');

            window.clearLeftFiltersCo2 = function() {
                window.leftFiltersCo2.slider('setValue', [slider_min, slider_max], true, false);
            };

        })();
        // endregion


        // region Price : Toggle Clear Btn
        window.toggleLeftFiltersPriceClearBtn = function() {
            var $clear_btn  = $('#fr_filter_price_clear_btn');
            if (!$clear_btn.length) return false;

            if (typeof window.leftFiltersPrice !== "undefined") {
                var slider_min = Math.round(window.leftFiltersPrice.attr('data-slider-min'));
                var slider_max = Math.round(window.leftFiltersPrice.attr('data-slider-max'));
                var values     = window.leftFiltersPrice.slider('getValue');
                var value_min  = Math.round(values[0]);
                var value_max  = Math.round(values[1]);

                if (value_min > slider_min || value_max < slider_max) {
                    $clear_btn.show();
                    return false;
                }
            }

            $clear_btn.hide();
        };
        // endregion

        // region Price : Min-Max
        (function() {
            var $input = $('#fr_filter_price');
            if (!$input.length) return false;

            var $label                = $('#fr_filter_price_label');
            var label_default         = $input.attr('data-label-default');
            var label_currency_symbol = $input.attr('data-currency-symbol');
            var slider_min            = Math.round($input.attr('data-slider-min'));
            var slider_max            = Math.round($input.attr('data-slider-max'));

            window.leftFiltersPrice = $input.slider({
                tooltip: 'hide',
                step: 0.1
            });

            window.leftFiltersPrice
                .on('slide', function () {
                    var values    = window.leftFiltersPrice.slider('getValue');
                    var value_min = Math.round(values[0]);
                    var value_max = Math.round(values[1]);

                    if (value_min === slider_min && value_max === slider_max) {
                        $label.text(label_default);
                    } else {
                        $label.text(label_currency_symbol + ' ' + value_min + ' - ' + ((value_max < slider_max) ? label_currency_symbol + ' ' + value_max : label_default));
                    }
                })
                .on('slideStop', function () {
                    window.leftFiltersPrice.trigger('slide');
                    window.toggleLeftFiltersPriceClearBtn();
                    window.updateFlightsSearchResults();
                }).trigger('slide');

            window.clearLeftFiltersPrice = function() {
                window.leftFiltersPrice.slider('setValue', [slider_min, slider_max], true, false);
            };

        })();
        // endregion


        // region Times : Tabs
        (function() {
            var $tab_times_dep_btn = $('#fr_filter_times_departure_tab_btn');
            var $tab_times_ret_btn = $('#fr_filter_times_return_tab_btn');

            var $tab_days_dep_btn = $('#fr_filter_days_departure_tab_btn');
            var $tab_days_ret_btn = $('#fr_filter_days_return_tab_btn');

            $tab_times_dep_btn.click(function(e) {
                if (!$tab_times_dep_btn.hasClass('active')) {
                    $tab_times_dep_btn.addClass('active');
                }
                if ($tab_times_ret_btn.hasClass('active')) {
                    $tab_times_ret_btn.removeClass('active');
                }
                $('#fr_filter_times_return_tab').hide();
                $('#fr_filter_times_departure_tab').show();

                if (typeof(e.isTrigger) === 'undefined') {
                    $tab_days_dep_btn.trigger('click');
                }
            });

            $tab_times_ret_btn.click(function(e) {
                if (!$tab_times_ret_btn.hasClass('active')) {
                    $tab_times_ret_btn.addClass('active');
                }
                if ($tab_times_dep_btn.hasClass('active')) {
                    $tab_times_dep_btn.removeClass('active');
                }
                $('#fr_filter_times_departure_tab').hide();
                $('#fr_filter_times_return_tab').show();

                if (typeof(e.isTrigger) === 'undefined') {
                    $tab_days_ret_btn.trigger('click');
                }
            });

            $('#fr_filter_times_departure_tab').show();

        })();
        // endregion

        // region Times : Departure : Return
        var times_filters = [
            {target : '#fr_filter_times_dep_dep', name : 'leftFiltersTimeDepDep'},
            {target : '#fr_filter_times_dep_arr', name : 'leftFiltersTimeDepArr'},
            {target : '#fr_filter_times_ret_dep', name : 'leftFiltersTimeRetDep'},
            {target : '#fr_filter_times_ret_arr', name : 'leftFiltersTimeRetArr'},
        ];

        window.toggleLeftFiltersTimesClearBtn = function() {
            var $clear_btn  = $('#fr_filter_times_clear_btn');
            if (!$clear_btn.length) return false;

            var is_used = false;
            times_filters.forEach(function (item) {
                if (typeof window[item.name] !== "undefined") {
                    var values = window[item.name].slider('getValue');
                    if (values[0] > 0 || values[1] < 24) {
                        is_used = true;
                        return false; // break
                    }
                }
            });

            if (is_used) {
                $clear_btn.show();
            } else {
                $clear_btn.hide();
            }
        };

        window.clearLeftFiltersTimes = function() {
            times_filters.forEach(function (item) {
                if (typeof window[item.name] !== "undefined") {
                    window[item.name].slider('setValue', [0, 24], true, false);
                }
            });

            var $tab_times_dep_btn = $('#fr_filter_times_departure_tab_btn');
            if ($tab_times_dep_btn.length) {
                $tab_times_dep_btn.trigger('click');
            }

            var $tab_days_dep_btn = $('#fr_filter_days_departure_tab_btn');
            if ($tab_days_dep_btn.length) {
                $tab_days_dep_btn.trigger('click');
            }
        };

        times_filters.forEach(function(item) {
            (function (target, name) {
                var $input = $(target);
                if (!$input.length) return false;

                var $label        = $(target + '_label');
                var label_default = $input.attr('data-label-default');
                var label_from    = $input.attr('data-label-from');
                var label_to      = $input.attr('data-label-to');
                var slider_min    = 0;
                var slider_max    = 24;

                window[name] = $input.slider({
                    tooltip: 'hide',
                    min: 0,
                    max: 24,
                    value: [0, 24]
                });

                window[name]
                    .on('slide', function () {
                        var values = window[name].slider('getValue');
                        if (values[0] === slider_min && values[1] === slider_max) {
                            $label.text(label_default);
                        } else {
                            var val0_label = values[0] > 23 ? '23:59' : (values[0] > 9 ? values[0] : '0' + values[0]) + ':00';
                            var val1_label = values[1] > 23 ? '23:59' : (values[1] > 9 ? values[1] : '0' + values[1]) + ':00';
                            $label.text(label_from + ' ' + val0_label + ' ' + label_to + ' ' + val1_label);
                        }
                    })
                    .on('slideStop', function () {
                        window[name].trigger('slide');
                        window.toggleLeftFiltersTimesClearBtn();
                        window.updateFlightsSearchResults();
                    }).trigger('slide');

            })(item.target, item.name);
        });
        // endregion


        // region Days : Tabs
        (function() {
            var $tab_days_dep_btn = $('#fr_filter_days_departure_tab_btn');
            var $tab_days_ret_btn = $('#fr_filter_days_return_tab_btn');

            var $tab_times_dep_btn = $('#fr_filter_times_departure_tab_btn');
            var $tab_times_ret_btn = $('#fr_filter_times_return_tab_btn');

            $tab_days_dep_btn.click(function(e) {
                if (!$tab_days_dep_btn.hasClass('active')) {
                    $tab_days_dep_btn.addClass('active');
                }
                if ($tab_days_ret_btn.hasClass('active')) {
                    $tab_days_ret_btn.removeClass('active');
                }
                $('#fr_filter_days_return_tab').hide();
                $('#fr_filter_days_departure_tab').show();

                if (typeof(e.isTrigger) === 'undefined') {
                    $tab_times_dep_btn.trigger('click');
                }
            });

            $tab_days_ret_btn.click(function(e) {
                if (!$tab_days_ret_btn.hasClass('active')) {
                    $tab_days_ret_btn.addClass('active');
                }
                if ($tab_days_dep_btn.hasClass('active')) {
                    $tab_days_dep_btn.removeClass('active');
                }
                $('#fr_filter_days_departure_tab').hide();
                $('#fr_filter_days_return_tab').show();

                if (typeof(e.isTrigger) === 'undefined') {
                    $tab_times_ret_btn.trigger('click');
                }
            });

            $('#fr_filter_days_departure_tab').show();

        })();
        // endregion

        // region Days : Departure : Return
        (function() {
            var toggleWD = function() {
                var $btn = $(this);
                if ($btn.hasClass('active')) {
                    $btn.removeClass('active');
                } else {
                    $btn.addClass('active');
                }

                window.toggleLeftFiltersDaysClearBtn();
                window.updateFlightsSearchResults();
            };
            $('#fr_filter_days_dep_container ._btn_wd').each(function() {
                $(this).click(toggleWD);
            });
            $('#fr_filter_days_ret_container ._btn_wd').each(function() {
                $(this).click(toggleWD);
            });

        })();

        window.toggleLeftFiltersDaysClearBtn = function() {
            var $clear_btn  = $('#fr_filter_days_clear_btn');
            if (!$clear_btn.length) return false;

            var is_used = false;

            $('#fr_filter_days_dep_container ._btn_wd').each(function() {
                if (!$(this).hasClass('active')) {
                    is_used = true;
                    return false; // break
                }
            });

            if (!is_used) {
                $('#fr_filter_days_ret_container ._btn_wd').each(function () {
                    if (!$(this).hasClass('active')) {
                        is_used = true;
                        return false; // break
                    }
                });
            }

            if (is_used) {
                $clear_btn.show();
            } else {
                $clear_btn.hide();
            }
        };

        window.clearLeftFiltersDays = function() {
            $('#fr_filter_days_dep_container ._btn_wd').each(function() {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active')
                }
            });
            $('#fr_filter_days_ret_container ._btn_wd').each(function() {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active')
                }
            });

            var $tab_times_dep_btn = $('#fr_filter_times_departure_tab_btn');
            if ($tab_times_dep_btn.length) {
                $tab_times_dep_btn.trigger('click');
            }

            var $tab_days_dep_btn = $('#fr_filter_days_departure_tab_btn');
            if ($tab_days_dep_btn.length) {
                $tab_days_dep_btn.trigger('click');
            }

        };
        // endregion


        // region Carriers (Airlines)
        (function() {
            $('#fr_filter_carriers_container input[type="checkbox"]').each(function() {
                $(this).click(function() {
                    window.toggleLeftFiltersCarriersClearBtn();
                    window.updateFlightsSearchResults();
                });
            });

            $('#fr_list_filter_carriers').keyup(function() {
                var test_str = $(this).val().toLowerCase();

                if (test_str.length) {
                    $('#fr_list_filter_carriers_btn_clear').show();
                } else {
                    $('#fr_list_filter_carriers_btn_clear').hide();
                }

                $('#fr_filter_carriers_container .form-group').each(function() {
                    if (!test_str.length || $(this).text().toLowerCase().indexOf(test_str) > -1) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            });

            $('#fr_list_filter_carriers_btn_clear').click(function() {
                $('#fr_list_filter_carriers').val('').focus().trigger('keyup');
            });

            $('#fr_list_filter_carriers_btn_select_all').click(function() {
                $('#fr_filter_carriers_container input').each(function() {
                    $(this).prop('checked', true);
                });
                window.toggleLeftFiltersCarriersClearBtn();
                window.updateFlightsSearchResults();
            });

            $('#fr_list_filter_carriers_btn_deselect_all').click(function() {
                $('#fr_filter_carriers_container input').each(function() {
                    $(this).prop('checked', false);
                });
                window.toggleLeftFiltersCarriersClearBtn();
                //window.updateFlightsSearchResults();
            });

        })();

        window.toggleLeftFiltersCarriersClearBtn = function() {
            var $clear_btn  = $('#fr_filter_carriers_clear_btn');
            if (!$clear_btn.length) return false;

            var is_used = false;

            $('#fr_filter_carriers_container input').each(function() {
                if (!$(this).prop('checked')) {
                    is_used = true;
                    return false; // break
                }
            });

            if (is_used) {
                $clear_btn.show();
            } else {
                $clear_btn.hide();
            }
        };

        window.clearLeftFiltersCarriers = function() {
            $('#fr_filter_carriers_container input').each(function() {
                $(this).prop('checked', true);
            });
            $('#fr_list_filter_carriers').val('').focus().trigger('keyup');
        };
        // endregion


        // region Airports
        (function() {
            $('#fr_filter_airports_container input[type="checkbox"]').each(function() {
                $(this).click(function() {
                    window.toggleLeftFiltersAirportsClearBtn();
                    window.updateFlightsSearchResults();
                });
            });

            $('#fr_list_filter_airports').keyup(function() {
                var test_str = $(this).val().toLowerCase();

                if (test_str.length) {
                    $('#fr_list_filter_airports_btn_clear').show();
                } else {
                    $('#fr_list_filter_airports_btn_clear').hide();
                }

                $('#fr_filter_airports_container .form-group').each(function() {
                    if (!test_str.length || $(this).text().toLowerCase().indexOf(test_str) > -1) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            });

            $('#fr_list_filter_airports_btn_clear').click(function() {
                $('#fr_list_filter_airports').val('').focus().trigger('keyup');
            });

            $('#fr_list_filter_airports_btn_select_all').click(function() {
                $('#fr_filter_airports_container input').each(function() {
                    $(this).prop('checked', true);
                });
                window.toggleLeftFiltersAirportsClearBtn();
                window.updateFlightsSearchResults();
            });

            $('#fr_list_filter_airports_btn_deselect_all').click(function() {
                $('#fr_filter_airports_container input').each(function() {
                    $(this).prop('checked', false);
                });
                window.toggleLeftFiltersAirportsClearBtn();
                //window.updateFlightsSearchResults();
            });

        })();

        window.toggleLeftFiltersAirportsClearBtn = function() {
            var $clear_btn  = $('#fr_filter_airports_clear_btn');
            if (!$clear_btn.length) return false;

            var is_used = false;

            $('#fr_filter_airports_container input').each(function() {
                if (!$(this).prop('checked')) {
                    is_used = true;
                    return false; // break
                }
            });

            if (is_used) {
                $clear_btn.show();
            } else {
                $clear_btn.hide();
            }
        };

        window.clearLeftFiltersAirports = function() {
            $('#fr_filter_airports_container input').each(function() {
                $(this).prop('checked', true);
            });
            $('#fr_list_filter_airports').val('').focus().trigger('keyup');
        };
        // endregion


        // region all filters Clear buttons
        (function() {

            var providers_clear_btn = $('#fr_filter_providers_clear_btn');
            if (providers_clear_btn.length) {
                providers_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersProviders();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var stops_clear_btn = $('#fr_filter_stops_clear_btn');
            if (stops_clear_btn.length) {
                stops_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersStops();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $duration_clear_btn = $('#fr_filter_duration_clear_btn');
            if ($duration_clear_btn.length) {
                $duration_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersDurationMaxTravelTime();
                    window.clearLeftFiltersDurationStopover();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $co2_clear_btn = $('#fr_filter_co2_clear_btn');
            if ($co2_clear_btn.length) {
                $co2_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersCo2();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $price_clear_btn = $('#fr_filter_price_clear_btn');
            if ($price_clear_btn.length) {
                $price_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersPrice();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $times_clear_btn = $('#fr_filter_times_clear_btn');
            if ($times_clear_btn.length) {
                $times_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersTimes();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $days_clear_btn = $('#fr_filter_days_clear_btn');
            if ($days_clear_btn.length) {
                $days_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersDays();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $carriers_clear_btn = $('#fr_filter_carriers_clear_btn');
            if ($carriers_clear_btn.length) {
                $carriers_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersCarriers();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

            var $airports_clear_btn = $('#fr_filter_airports_clear_btn');
            if ($airports_clear_btn.length) {
                $airports_clear_btn.click(function(e) {
                    e.stopPropagation();
                    window.clearLeftFiltersAirports();
                    $(this).hide();
                    window.updateFlightsSearchResults();
                });
            }

        })();
        // endregion

        $('#sr_filters_close').click(function() {
            $('#search_results_filters_header').hide();
            $('#search_results_filters').removeClass('_sr_filters_mobile_open');
            $('#search_results_filters').css('top', '');
            $('#search_results_wrapper').show();
            $('html').css('overflow-y', 'scroll');

            window.updateActiveFiltersStat();
            window.updateFlightsSearchResults(true);
        });

        $('#sr_filters_reset').click(function() {
            $('._fr_filter_clear_btn:visible').each(function() {
                $(this).click();
            });
            $('#sr_filters_close').click();
        });

        $('#btn_apply_filters').click(function() {
            $('#sr_filters_close').click();
        });

        window.updateActiveFiltersStat();

        var $sr_filters_stat_total = $('#sr_filters_stat_total');
        if ($sr_filters_stat_total.length && (parseInt($sr_filters_stat_total.text()) || 0) > 0) {
            $('#btn_toggle_filters').show();
        }
    };

    window.initFlightsSearchForm = function() {

        // prevent closing of dropdown menu when inner buttons are used
        $('#header_search_form_travellers_dropdown_menu').click(function(ev) {
            ev.stopPropagation();
        });

        // region close dropdown menu on flight type and selected cabins focus
        var closeTravellersDropdown = function() {
            $('#header_search_form_travellers_dropdown_menu').removeClass('show');
        };
        $('#header_search_form_flight_type').focus(closeTravellersDropdown);
        $('#header_search_form_selected_cabins').focus(closeTravellersDropdown);
        // endregion

        var $filter_adults   = $('#filter_adults');
        var $filter_children = $('#filter_children');
        var $filter_infants  = $('#filter_infants');

        var $filter_btn_sub_adults = $('#filter_btn_sub_adults');
        var $filter_btn_add_adults = $('#filter_btn_add_adults');

        var $filter_btn_sub_children = $('#filter_btn_sub_children');
        var $filter_btn_add_children = $('#filter_btn_add_children');

        var $filter_btn_sub_infants = $('#filter_btn_sub_infants');
        var $filter_btn_add_infants = $('#filter_btn_add_infants');

        var setControlBtnState = function() {
            var adults       = parseInt($filter_adults.val())   || 0;
            var children     = parseInt($filter_children.val()) || 0;
            var infants      = parseInt($filter_infants.val())  || 0;
            var num_travelers = adults + children + infants;

            // reset disabled state
            if ($filter_btn_sub_adults.hasClass('disabled')) {
                $filter_btn_sub_adults.removeClass('disabled');
            }
            if ($filter_btn_add_adults.hasClass('disabled')) {
                $filter_btn_add_adults.removeClass('disabled');
            }
            if ($filter_btn_sub_children.hasClass('disabled')) {
                $filter_btn_sub_children.removeClass('disabled');
            }
            if ($filter_btn_add_children.hasClass('disabled')) {
                $filter_btn_add_children.removeClass('disabled');
            }
            if ($filter_btn_sub_infants.hasClass('disabled')) {
                $filter_btn_sub_infants.removeClass('disabled');
            }
            if ($filter_btn_add_infants.hasClass('disabled')) {
                $filter_btn_add_infants.removeClass('disabled');
            }

            // check sum of passengers
            if (num_travelers >= 9) {
                if (!$filter_btn_add_adults.hasClass('disabled')) {
                    $filter_btn_add_adults.addClass('disabled');
                }
                if (!$filter_btn_add_children.hasClass('disabled')) {
                    $filter_btn_add_children.addClass('disabled');
                }
                if (!$filter_btn_add_infants.hasClass('disabled')) {
                    $filter_btn_add_infants.addClass('disabled');
                }
            }

            // check individual buttons
            if (adults < 2 && !$filter_btn_sub_adults.hasClass('disabled')) {
                $filter_btn_sub_adults.addClass('disabled');
            }
            if (children < 1 && !$filter_btn_sub_children.hasClass('disabled')) {
                $filter_btn_sub_children.addClass('disabled');
            }
            if (infants < 1 && !$filter_btn_sub_infants.hasClass('disabled')) {
                $filter_btn_sub_infants.addClass('disabled');
            }
            if (infants >= adults && !$filter_btn_add_infants.hasClass('disabled')) {
                $filter_btn_add_infants.addClass('disabled');
            }

            // update travellers dropdown menu label
            var $travellers_menu = $('#header_search_form_travellers_dropdown_menu_btn');
            $travellers_menu.text(
                num_travelers
                + ' '
                + ((num_travelers > 1) ? $travellers_menu.attr('data-label-pl') : $travellers_menu.attr('data-label'))
            );
        }

        // noinspection JSUnresolvedVariable
        var s2_location_options = {
            ajax: {
                url: siteData.ajaxUrl,
                dataType: 'json',
                delay: 100,
                data: function (params) {
                    return {
                        search: params.term,
                        action: 'flights_search_location'
                    };
                }
            },
            minimumInputLength: 2,
            dropdownCssClass: 'flights_location_dropdown',
            language: window.siteData.language
        };

        $('#filter_fly_from')
            .select2(s2_location_options)
            .on('select2:select', function() {
                $(this).parent().removeClass('_select2_container_err');
            });

        $('#filter_fly_to')
            .select2(s2_location_options)
            .on('select2:select', function() {
                $(this).parent().removeClass('_select2_container_err');
            });


        $filter_btn_sub_adults.click(function () {
            if ($(this).hasClass('disabled')) return false;

            var adults  = parseInt($filter_adults.val())  || 0;
            var infants = parseInt($filter_infants.val()) || 0;

            adults --;
            if (infants > adults) {
                infants --;
                $filter_infants.val(infants);
            }
            $filter_adults.val(adults);

            setControlBtnState();
        });
        $filter_btn_add_adults.click(function () {
            if ($(this).hasClass('disabled')) return false;
            $filter_adults.val((parseInt($filter_adults.val()) || 0) + 1);
            setControlBtnState();
        });

        $filter_btn_sub_children.click(function () {
            if ($(this).hasClass('disabled')) return false;
            $filter_children.val((parseInt($filter_children.val()) || 0) - 1);
            setControlBtnState();
        });
        $filter_btn_add_children.click(function () {
            if ($(this).hasClass('disabled')) return false;
            $filter_children.val((parseInt($filter_children.val()) || 0) + 1);
            setControlBtnState();
        });

        $filter_btn_sub_infants.click(function () {
            if ($(this).hasClass('disabled')) return false;
            $filter_infants.val((parseInt($filter_infants.val()) || 0) - 1);
            setControlBtnState();
        });
        $filter_btn_add_infants.click(function () {
            if ($(this).hasClass('disabled')) return false;
            $filter_infants.val((parseInt($filter_infants.val()) || 0) + 1);
            setControlBtnState();
        });

        setControlBtnState();

        // region date(range) picker locale
        var date_picker_locale = {
            "format": "DD/MM/YYYY",
            "fromLabel": "Departure",
            "toLabel": "Return",
            "daysOfWeek": [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            "monthNames": [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            "firstDay": 1,
            "applyLabel":  window.siteData.calendar_apply_label,
            "cancelLabel": window.siteData.calendar_cancel_label
        };

        if (window.siteData.language === 'de') {
            date_picker_locale.fromLabel  = 'Abflug';
            date_picker_locale.toLabel    = 'Rückflug';
            date_picker_locale.daysOfWeek = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
            date_picker_locale.monthNames = [
                "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli",
                "August", "September", "Oktober", "November", "Dezember"
            ];
        }
        // endregion

        window.sf_calendar_type = null;

        var initSearchFormCalendarInstructionTooltips = function() {
            var tippy_options = {
                //theme: 'light',
                maxWidth: 320,
                content: window.siteData.tooltip_calendar_select_date_inst
            };
            tippy('#flights_date_fr_dmy', tippy_options);
            tippy('#flights_date_to_dmy', tippy_options);
        };
        initSearchFormCalendarInstructionTooltips();

        var removeSearchFormDatePickers = function() {

            // remove date-range picker
            try {
                var dp_fr_obj = $('#flights_date_fr_dmy').data('daterangepicker');
                var dp_to_obj = $('#flights_date_to_dmy').data('daterangepicker');

                dp_fr_obj.element.trigger('hide.daterangepicker', dp_fr_obj);
                dp_to_obj.element.trigger('hide.daterangepicker', dp_to_obj);

                dp_fr_obj.remove();
                dp_to_obj.remove();

            } catch (err) {}

            // disable calendar selection instructions
            try {
                document.querySelector('#flights_date_fr_dmy')._tippy.disable();
                document.querySelector('#flights_date_to_dmy')._tippy.disable();
            } catch (err) {}

            // unbind date 'to' field from opening the date 'from' calendar on click
            $('#flights_date_to_dmy').unbind('click');

            // hide fullscreen calendar container if available
            if ($("#fullscreen_calendar_container").length) {
                $("#fullscreen_calendar_container").hide();
            }
        };

        var initSearchFormFullscreenDateRangePicker = function(force_init) {

            if (!force_init && window.sf_calendar_type === 'fullscreen') {
                return false; // calendar type already initialised
            }
            window.sf_calendar_type = 'fullscreen';

            removeSearchFormDatePickers();

            var flight_type = $('#header_search_form_flight_type option:selected').val();
            var dp_options = {
                "parentEl": "#fullscreen_calendar_container",
                "linkedCalendars": false,
                "autoApply" : false,
                "autoUpdateInput" : false,
                "singleDatePicker" : false,
                "opens": "left",
                "drops": "up",
                "minDate" : moment().startOf('day')
            };
            dp_options.locale   = date_picker_locale;
            dp_options.template = $('#dr_picker_template').html();

            if (flight_type === 'oneway') {
                dp_options.singleDatePicker = true;
            }

            var prev_html_overflow_y = '';

            var $datepicker = $('#flights_date_fr_dmy').daterangepicker(dp_options);
            var datepicker_obj = $datepicker.data('daterangepicker');

            // overwrite move function
            datepicker_obj.move = function() {
                this.container.css({
                    top: 'auto',
                    bottom: 0,
                    left: 0,
                    right: 'auto'
                });
            };

            // disable closing of calendar when clicked outside of container
            datepicker_obj.outsideClick = function() {};


            var $drp_dep = $('.drp-type-group>.drp-type-dep', datepicker_obj.container);
            var $drp_arr = $('.drp-type-group>.drp-type-arr', datepicker_obj.container);

            $drp_dep.click($.proxy(function(e) {
                this.setEndDate(this.startDate.clone());
                this.setStartDate(this.startDate.clone());
                this.updateView();
            }, datepicker_obj));

            $drp_arr.click($.proxy(function(e) {
                this.endDate = null;
                this.setStartDate(this.startDate.clone());
                this.updateView();
            }, datepicker_obj));


            datepicker_obj.updateView = $.proxy(function() {
                if (this.endDate)
                    this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
                this.updateMonthsInView();
                this.updateCalendars();
                this.updateFormInputs();

                var $drp_dep = $('.drp-type-group>.drp-type-dep', this.container);
                var $drp_arr = $('.drp-type-group>.drp-type-arr', this.container);
                $('.drp-value', $drp_dep).text(this.startDate.format('DD/MM/YYYY'));

                $drp_dep.removeClass('active');
                $drp_arr.removeClass('active');

                if (null == this.endDate) {
                    // date selection is taking place, highlight return box
                    $drp_arr.addClass('active');

                } else {
                    $drp_dep.addClass('active');

                    // date selection has ended
                    if (this.endDate.isValid()) {
                        $('.drp-value', $drp_arr).text(this.endDate.format('DD/MM/YYYY'));
                    }
                }

            }, datepicker_obj);

            $datepicker
                .on('show.daterangepicker', function(ev, picker) {

                    if (dp_options.singleDatePicker) {
                        $('.drp-type-group', picker.container).hide();
                    } else {
                        $('.drp-type-group', picker.container).css('display', 'flex');
                    }

                    $('#flights_date_fr_dmy').blur();
                    $('#flights_date_to_dmy').blur();

                    var date_fr = $('#flights_date_fr_dmy').val();
                    var date_to = $('#flights_date_to_dmy').val();

                    if (date_fr) {
                        picker.setStartDate(date_fr);
                    } else {
                        picker.setStartDate(picker.minDate)
                    }

                    if (!picker.singleDatePicker) {
                        if (date_to && date_to !== 'Anytime') {
                            picker.setEndDate(date_to);
                        } else {
                            picker.setEndDate(date_fr);
                        }

                        $('.dr_picker_ret_anytime', picker.container).change(function () {
                            var is_checked = $(this).prop('checked');
                            if (!is_checked) return false;

                            $(this).prop('checked', false);
                            $('#flights_date_from').val(picker.startDate.format('YYYY-MM-DD'));
                            $('#flights_date_fr_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                            $('#flights_date_fr_dmy').parent().removeClass('_input_container_err');

                            $('#flights_date_to').val('');
                            $('#flights_date_to_dmy').val('');
                            $('#flights_date_to_dmy').attr('placeholder', $('#flights_date_to_dmy').attr('data-placeholder-round-anytime'));
                            $('#flights_date_to_dmy').parent().removeClass('_input_container_err');

                            picker.hide();
                        });

                    } else {
                        $('.drp-header', picker.container).hide();
                    }

                    if (!window.siteData.search_return_anytime_enabled) {
                        $('.drp-header', picker.container).hide(); // hide header containing 'return anytime' checkbox
                    }

                    picker.container.addClass('single');
                    picker.container.find('.drp-calendar.left').addClass('single').show();
                    picker.container.find('.drp-calendar.right').hide();
                    picker.container.css('border-radius', '0');

                    picker.updateView();
                    $(dp_options.parentEl).fadeIn();

                    prev_html_overflow_y = $('html').css('overflow-y');
                    $('html').css('overflow-y', 'hidden');
                })
                .on('hide.daterangepicker', function() {
                    $(dp_options.parentEl).hide();
                    $('html').css('overflow-y', prev_html_overflow_y);
                })
                .on('apply.daterangepicker', function(ev, picker) {
                    $('#flights_date_from').val(picker.startDate.format('YYYY-MM-DD'));
                    $('#flights_date_fr_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                    $('#flights_date_fr_dmy').parent().removeClass('_input_container_err');

                    if (!picker.singleDatePicker) {
                        $('#flights_date_to').val(picker.endDate.format('YYYY-MM-DD'));
                        $('#flights_date_to_dmy').val(picker.endDate.format('DD/MM/YYYY'));
                        $('#flights_date_to_dmy').parent().removeClass('_input_container_err');
                    }

                    $('#dr_picker_ret_anytime', picker.container).prop('checked', false);
                });

            $('#flights_date_to_dmy').click(function() {
                $('#flights_date_fr_dmy').data('daterangepicker').show();
            });
        };

        var initSearchFormDualDatePickers = function(force_init) {

            if (!force_init && window.sf_calendar_type === 'dual') {
                return false; // calendar type already initialised
            }
            window.sf_calendar_type = 'dual';

            removeSearchFormDatePickers();

            var flight_type = $('#header_search_form_flight_type option:selected').val();
            var dp_options = {
                "autoApply" : true,
                "autoUpdateInput" : false,
                "singleDatePicker" : true,
                "opens": "center",
                "minDate" : moment().startOf('day')
            };
            dp_options.locale   = date_picker_locale;
            dp_options.template = $('#dr_picker_template').html();

            var updateInfoMessageStatus = function(scroll_page) {
                var $msg = $('#msg_select_return_date');
                if ($msg.length) {

                    var $f_date_fr = $('#flights_date_fr_dmy');
                    var $f_date_to = $('#flights_date_to_dmy');

                    // only display message if return trip and departure date are selected, but no return option chosen
                    // return trip is determined by placeholder value
                    if ($f_date_fr.val() && !$f_date_to.val() && $f_date_to.attr('placeholder') === $f_date_to.attr('data-placeholder-round')) {
                        $msg.show();
                    } else {
                        $msg.hide();
                    }

                    if (scroll_page) {
                        // scroll to date field
                        $("html, body").animate({scrollTop: $('#flights_date_to_dmy').offset().top - 12}, 350);
                    }
                }
            };

            updateInfoMessageStatus();

            $('#flights_date_fr_dmy').daterangepicker(dp_options)
                .on('show.daterangepicker', function(ev, picker) {

                    $('.drp-type-group', picker.container).hide(); //only show dep/ret buttons on fullscreen calendar

                    var date_from = $('#flights_date_fr_dmy').val();
                    if (date_from) {
                        picker.setStartDate(date_from);
                        picker.setEndDate(date_from);
                    } else {
                        picker.setStartDate(picker.minDate.clone())
                        picker.setEndDate(picker.minDate.clone())
                    }

                    $('.drp-header', picker.container).hide(); // hide header containing 'return anytime' checkbox

                    $('#flights_date_fr_dmy').prop('disabled', true);

                    picker.updateView();

                    $(picker.container).css('left', '16px');
                    $(picker.container).css('min-width', '');
                    $(picker.container).css('max-width', 'calc(100% - 32px)');
                    $(picker.container).css('width',     'calc(100% - 32px)');
                    $('.drp-calendar', picker.container).css('max-width', 'calc(100% - 20px)');

                    // scroll to date field
                    $("html, body").animate({ scrollTop: $('#flights_date_fr_dmy').offset().top - 12 }, 350);

                })
                .on('hide.daterangepicker', function() {
                    $('#flights_date_fr_dmy').prop('disabled', false);
                })
                .on('apply.daterangepicker', function(ev, picker) {
                    $('#flights_date_from').val(picker.startDate.format('YYYY-MM-DD'));
                    $('#flights_date_fr_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                    $('#flights_date_fr_dmy').parent().removeClass('_input_container_err');

                    var $to_dp = $('#flights_date_to_dmy').data('daterangepicker');
                    if ($to_dp) {

                        if ($('#flights_date_to').val() && picker.startDate > $to_dp.startDate) {
                            $to_dp.setStartDate(picker.startDate.clone());
                            $to_dp.setEndDate(picker.startDate.clone());

                            $('#flights_date_to').val(picker.startDate.format('YYYY-MM-DD'));
                            $('#flights_date_to_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                        }

                        $to_dp.minDate = picker.startDate;
                        updateInfoMessageStatus(true);
                    }
                });

            if (flight_type === 'oneway') return; // skip init of second calendar if oneway trip is selected

            $('#flights_date_to_dmy').daterangepicker(dp_options)
                .on('show.daterangepicker', function(ev, picker) {

                    $('.drp-type-group', picker.container).hide(); //only show dep/ret buttons on fullscreen calendar

                    var date_to = $('#flights_date_to_dmy').val();
                    if (date_to) {
                        picker.setStartDate(date_to);
                        picker.setEndDate(date_to);
                    } else {
                        picker.setStartDate(picker.minDate.clone())
                        picker.setEndDate(picker.minDate.clone())
                    }

                    // ensure date_to is higher or equal to date_form
                    var $fr_dp = $('#flights_date_fr_dmy').data('daterangepicker');
                    if ($fr_dp && $fr_dp.endDate > picker.startDate) {
                        picker.setStartDate($fr_dp.endDate.clone())
                        picker.setEndDate($fr_dp.endDate.clone())
                    }

                    $('.dr_picker_ret_anytime', picker.container).change(function () {
                        var is_checked = $(this).prop('checked');
                        if (!is_checked) return false;

                        $(this).prop('checked', false);

                        $('#flights_date_to').val('');
                        $('#flights_date_to_dmy').val('');
                        $('#flights_date_to_dmy').attr('placeholder', $('#flights_date_to_dmy').attr('data-placeholder-round-anytime'));
                        $('#flights_date_to_dmy').parent().removeClass('_input_container_err');

                        picker.hide();
                        updateInfoMessageStatus(true);
                    });

                    $('#flights_date_to_dmy').prop('disabled', true);

                    if (!window.siteData.search_return_anytime_enabled) {
                        $('.drp-header', picker.container).hide(); // hide header containing 'return anytime' checkbox
                    }

                    picker.updateView();

                    $(picker.container).css('left', '16px');
                    $(picker.container).css('min-width', '');
                    $(picker.container).css('max-width', 'calc(100% - 32px)');
                    $(picker.container).css('width',     'calc(100% - 32px)');
                    $('.drp-calendar', picker.container).css('max-width', 'calc(100% - 20px)');

                    // scroll to date field
                    $("html, body").animate({ scrollTop: $('#flights_date_to_dmy').offset().top - 12 }, 350);

                })
                .on('hide.daterangepicker', function() {
                    $('#flights_date_to_dmy').prop('disabled', false);
                })
                .on('apply.daterangepicker', function(ev, picker) {
                    $('#flights_date_to').val(picker.startDate.format('YYYY-MM-DD'));
                    $('#flights_date_to_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                    $('#flights_date_to_dmy').parent().removeClass('_input_container_err');

                    $('#dr_picker_ret_anytime', picker.container).prop('checked', false);
                    updateInfoMessageStatus(true);
                });
        };

        var initSearchFormDateRangePicker = function(force_init) {

            if (!force_init && window.sf_calendar_type === 'range') {
                return false; // calendar type already initialised
            }
            window.sf_calendar_type = 'range';

            removeSearchFormDatePickers();

            var flight_type = $('#header_search_form_flight_type option:selected').val();
            var dp_options = {
                "autoApply" : true,
                "autoUpdateInput" : false,
                "singleDatePicker" : false,
                "opens": "left",
                "minDate" : moment().startOf('day')
            };
            dp_options.locale   = date_picker_locale;
            dp_options.template = $('#dr_picker_template').html();

            if (flight_type === 'oneway') {
                dp_options.singleDatePicker = true;
            }

            var dpPrevSelTime    = null;
            var checkDoubleClick = function(picker) {

                // check if prompt is enabled in admin
                if (!window.siteData.calendar_sameday_prompt_enabled) return;

                // only display prompt for ranged calendars
                if (picker.singleDatePicker) return;

                // only display prompt if the same day is selected
                if (picker.startDate.format('YYYY-MM-DD') !== picker.endDate.format('YYYY-MM-DD')) return;

                var click_time = 0;
                if (dpPrevSelTime) {
                    var dpLastSelTime = new Date();
                    click_time = dpLastSelTime.getTime() - dpPrevSelTime.getTime();
                }

                // only display prompt if timeout is > 0 and click time is <= timeout
                var timeout = parseInt(window.siteData.calendar_sameday_dblclick_timeout) || 0;
                if (click_time && timeout && click_time > timeout) return;

                var $modal = $('#calendar_sameday_popup_modal');
                if (!$modal.length) return;

                var $btn_retry = $('._btn_retry', $modal);
                if ($btn_retry.length) {
                    $btn_retry.unbind().click(function () {
                        $modal.modal('hide');
                        $('#flights_date_fr_dmy').data('daterangepicker').show();
                    });
                }

                var $btn_ok = $('._btn_ok', $modal);
                if ($btn_ok.length) {
                    $btn_ok.unbind().click(function () {
                        $modal.modal('hide');

                        if (window.siteData.calendar_sameday_prompt_btn_ok_action === 'open_calendar') {
                            $('#flights_date_fr_dmy').data('daterangepicker').show();
                        }
                    });
                }

                $modal.modal();
            };

            $('#flights_date_fr_dmy').daterangepicker(dp_options)
                .on('show.daterangepicker', function(ev, picker) {

                    $('.drp-type-group', picker.container).hide(); //only show dep/ret buttons on fullscreen calendar

                    var date_fr = $('#flights_date_fr_dmy').val();
                    var date_to = $('#flights_date_to_dmy').val();

                    if (date_fr) {
                        picker.setStartDate(date_fr);
                    } else {
                        picker.setStartDate(picker.minDate)
                    }

                    if (!picker.singleDatePicker) {
                        if (date_to && date_to !== 'Anytime') {
                            picker.setEndDate(date_to);
                        } else {
                            picker.setEndDate(date_fr);
                        }

                        $('.dr_picker_ret_anytime', picker.container).change(function () {
                            var is_checked = $(this).prop('checked');
                            if (!is_checked) return false;

                            $(this).prop('checked', false);
                            $('#flights_date_from').val(picker.startDate.format('YYYY-MM-DD'));
                            $('#flights_date_fr_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                            $('#flights_date_fr_dmy').parent().removeClass('_input_container_err');

                            $('#flights_date_to').val('');
                            $('#flights_date_to_dmy').val('');
                            $('#flights_date_to_dmy').attr('placeholder', $('#flights_date_to_dmy').attr('data-placeholder-round-anytime'));
                            $('#flights_date_to_dmy').parent().removeClass('_input_container_err');

                            picker.hide();
                        });

                    } else {
                        $('.drp-header', picker.container).hide();
                    }

                    $('#flights_date_fr_dmy').prop('disabled', true);

                    if (flight_type === 'round') {
                        $('#flights_date_to_dmy').prop('disabled', true);
                    }

                    if (!window.siteData.search_return_anytime_enabled) {
                        $('.drp-header', picker.container).hide(); // hide header containing 'return anytime' checkbox
                    }

                    picker.updateView();

                    picker.container.find('.drp-calendar')
                        .off('mousedown.dp_select_times', 'td.available')
                        .on('mousedown.dp_select_times', 'td.available', function() {
                            dpPrevSelTime = new Date();
                        });
                })
                .on('hide.daterangepicker', function() {
                    $('#flights_date_fr_dmy').prop('disabled', false);
                    if (flight_type === 'round') {
                        $('#flights_date_to_dmy').prop('disabled', false);
                    }
                })
                .on('apply.daterangepicker', function(ev, picker) {
                    $('#flights_date_from').val(picker.startDate.format('YYYY-MM-DD'));
                    $('#flights_date_fr_dmy').val(picker.startDate.format('DD/MM/YYYY'));
                    $('#flights_date_fr_dmy').parent().removeClass('_input_container_err');

                    if (!picker.singleDatePicker) {
                        $('#flights_date_to').val(picker.endDate.format('YYYY-MM-DD'));
                        $('#flights_date_to_dmy').val(picker.endDate.format('DD/MM/YYYY'));
                        $('#flights_date_to_dmy').parent().removeClass('_input_container_err');
                    }

                    $('#dr_picker_ret_anytime', picker.container).prop('checked', false);

                    if (flight_type === 'round') {
                        $('#flights_date_to_dmy').prop('disabled', false);
                    }

                    checkDoubleClick(picker);
                });

            $('#flights_date_to_dmy').click(function() {
                $('#flights_date_fr_dmy').data('daterangepicker').show();
            });
        };


        var updateDepArrCalendarType = function(force_init) {
            if (window.innerWidth < 1140) {

                // mobile/tablet
                if (window.siteData.calendar_mobile_fullscreen_enabled) {
                    initSearchFormFullscreenDateRangePicker(force_init);
                } else {
                    initSearchFormDualDatePickers(force_init);
                }

            } else {
                initSearchFormDateRangePicker(force_init); // desktop
            }
        };

        var depArrCalendarResizeTimer;
        window.addEventListener("resize", function() {
            clearTimeout(depArrCalendarResizeTimer);
            depArrCalendarResizeTimer = setTimeout(updateDepArrCalendarType, 500);
        }, {
            capture: true,
            passive: true
        });

        $('#header_search_form_flight_type').change(function() {
            var $f_date_to = $('#flights_date_to_dmy');

            var flight_type = $('#header_search_form_flight_type option:selected').val();
            switch(flight_type) {
                case 'round':
                    $('#header_search_form_flight_type_group_round').removeClass('btn-light').addClass('btn-success');
                    $('#header_search_form_flight_type_group_oneway').removeClass('btn-success').addClass('btn-light');

                    $f_date_to
                        .attr('placeholder', $f_date_to.attr('data-placeholder-round'))
                        .prop('disabled', false);

                    break;
                case 'oneway':
                    $('#header_search_form_flight_type_group_round').removeClass('btn-success').addClass('btn-light');
                    $('#header_search_form_flight_type_group_oneway').removeClass('btn-light').addClass('btn-success');

                    $f_date_to
                        .val('')
                        .attr('placeholder', $f_date_to.attr('data-placeholder-oneway'))
                        .prop('disabled', true);

                    $f_date_to.parent().removeClass('_input_container_err');
                    break;
            }

            updateDepArrCalendarType(true);

        }).change();

        var flightTypeGroupBtnClick = function() {
            $('#header_search_form_flight_type').val($(this).attr('data-ft')).change();
        };
        $('#header_search_form_flight_type_group_round').click(flightTypeGroupBtnClick);
        $('#header_search_form_flight_type_group_oneway').click(flightTypeGroupBtnClick);

        var $search_form_toolbar = $('#search_form_toolbar');
        if ($search_form_toolbar.length) {
            $('._trip', $search_form_toolbar).click(function() {
                $('#header_booking_form_block').toggleClass('_search_form_mobile_hidden');
            });
            $('#btn_toggle_filters').click(function() {
                $('#search_results_filters_header').toggle();
                $('#search_results_filters').toggleClass('_sr_filters_mobile_open');

                if ($('#search_results_filters').hasClass('_sr_filters_mobile_open')) {
                    $('#search_results_wrapper').hide();
                    $('html').css('overflow-y', 'hidden');

                    if ($('#wpadminbar').length) {
                        $('#search_results_filters_header').css('top', $('#wpadminbar').height() + 'px');
                        $('#search_results_filters').css('top', ($('#wpadminbar').height() + 95) + 'px');
                    }
                } else {
                    $('#search_results_wrapper').show();
                    $('html').css('overflow-y', 'scroll');
                }
            });
        }
    };

    window.showFlightsSearchLoadInd = function(scroll_to_top) {
        $('#flights_search_result_load_ind').fadeIn();

        // scroll window to top
        if (scroll_to_top) {
            window.scrollTo(0, 0);
        }
    };

    window.hideFlightsSearchLoadInd = function(scroll_to_top) {
        $('#flights_search_result_load_ind').fadeOut();

        // scroll window to top
        if (scroll_to_top) {
            window.scrollTo(0, 0);
        }
    };

    window.updateFlightsSearchResults = function(scroll_to_top, sort_by, sort_dir, page) {

        // do not update search results while mobile filter menu is open
        // mobile menu wil update when 'Apply filters' button is clicked ( no _sr_filters_mobile_open class )
        if ($('#search_results_filters').hasClass('_sr_filters_mobile_open')) {
            return false;
        }

        var $form =  $('#header_search_form');
        if (!$form.length) return false;

        if (sort_by) {
            $('input[name="sort_by"]', $form).val(sort_by);
        }

        if (sort_dir) {
            $('input[name="sort_dir"]', $form).val(sort_dir);
        }

        var data = $form.serializeArray();

        if (!page) {
            page = 1;
        }
        data.push({name: 'rp', value: page});

        // region filters
        var filters = {
            wd_dep   : [],
            wd_ret   : [],
            carriers : [],
            airports : [],
        };

        var $f_stops = $('#left_stops_section input[name="fr_filter_stops"]:checked');
        if ($f_stops.length) {
            filters.stops = $f_stops.val();
        }

        var $f_allow_overnight_stopovers = $('#left_stops_section #fr_filter_stops_allow_overnight');
        if ($f_allow_overnight_stopovers.length) {
            filters.allow_overnight_stopovers = $f_allow_overnight_stopovers.prop('checked') ? 1 : 0;
        }

        if (typeof window.leftFiltersDurationMaxTravelTime !== "undefined") {
            filters.duration_max_travel_time = Math.round(window.leftFiltersDurationMaxTravelTime.slider('getValue'));
        }

        if (typeof window.leftFiltersDurationStopover !== "undefined") {
            var stopover_values = window.leftFiltersDurationStopover.slider('getValue');
            filters.duration_stopover_min = Math.round(stopover_values[0]);
            filters.duration_stopover_max = Math.round(stopover_values[1]);
        }

        if (typeof window.leftFiltersCo2 !== "undefined") {
            var co2_values = window.leftFiltersCo2.slider('getValue');
            filters.co2_min = Math.round(co2_values[0]);
            filters.co2_max = Math.round(co2_values[1]);
        }

        if (typeof window.leftFiltersPrice !== "undefined") {
            var price_values = window.leftFiltersPrice.slider('getValue');
            filters.price_min = Math.round(price_values[0]);
            filters.price_max = Math.round(price_values[1]);
        }

        var times_filters = [
            {name : 'leftFiltersTimeDepDep', 'fp' : 'times_dep_dep'},
            {name : 'leftFiltersTimeDepArr', 'fp' : 'times_dep_arr'},
            {name : 'leftFiltersTimeRetDep', 'fp' : 'times_ret_dep'},
            {name : 'leftFiltersTimeRetArr', 'fp' : 'times_ret_arr'}
        ];
        times_filters.forEach(function (item) {
            if (typeof window[item.name] !== "undefined") {
                var values = window[item.name].slider('getValue');
                filters[item.fp + '_min'] = values[0];
                filters[item.fp + '_max'] = values[1];
            }
        });

        $('#fr_filter_days_dep_container ._btn_wd').each(function() {
            if ($(this).hasClass('active')) {
                filters.wd_dep.push($(this).attr('data-wd'));
            }
        });
        $('#fr_filter_days_ret_container ._btn_wd').each(function() {
            if ($(this).hasClass('active')) {
                filters.wd_ret.push($(this).attr('data-wd'));
            }
        });

        $('#fr_filter_carriers_container input').each(function() {
            if ($(this).prop('checked')) {
                filters.carriers.push($(this).val());
            }
        });

        $('#fr_filter_airports_container input').each(function() {
            if ($(this).prop('checked')) {
                filters.airports.push($(this).val());
            }
        });

        if ($('#fr_filter_providers_container').length) {
            filters.providers = [];

            $('#fr_filter_providers_container input').each(function () {
                if ($(this).prop('checked')) {
                    filters.providers.push($(this).val());
                }
            });
        }

        data.push({name: 'filters', value: JSON.stringify(filters)});
        // endregion

        // abort previous request
        if (typeof window.flights_search_update_xhr !== "undefined") {
            window.flights_search_update_xhr.abort();
        }

        // noinspection JSUnresolvedVariable
        window.flights_search_update_xhr = $.ajax({
            type: "POST",
            url: siteData.ajaxUrl + '?action=flights_update_results',
            data: data,
            dataType: 'json',
            beforeSend: function() {

                // show loading ind
                window.showFlightsSearchLoadInd(scroll_to_top);
            },
            success: function(data) {

                $('#flights_search_result_sort_tabs_container').html(data.result_sort_tabs);
                $('#flights_search_result_cards_container').html(data.result_cards_html);
                $('#sr_filters_stat_loaded').text(data.nof_items);

                // hide loading ind
                window.hideFlightsSearchLoadInd();

                // trigger the post-load event after content has been inserted via Ajax
                $(document.body).trigger('post-load');

                window.updateActiveFiltersStat();
            }
        });
    };

    $(function(){ //document.ready

        // region Enable mobile menu.
        $('.nav-primary > div > ul.nav').slicknav({
            closeOnClick: true,
            closedSymbol: '<i class="fal fa-angle-down" aria-hidden="true"></i>',
            openedSymbol: '<i class="fal fa-angle-up" aria-hidden="true"></i>',
            label: '',
            appendTo: 'header.banner > .container-fluid'
        });
        // endregion

        // region Save scroll position
        $(document).on('click', '[data-save-scroll-top]', function () {
            if (localStorage) {
                localStorage.setItem('scrollTop', $(window).scrollTop());
            }
        });

        if (localStorage) {
            var savedScrollTop = localStorage.getItem('scrollTop');
            if (savedScrollTop) {
                jQuery(window).scrollTop(savedScrollTop);
                localStorage.removeItem('scrollTop');
            }
        }
        // endregion

        // region read more
        $(document).find('[data-read-more]').on('click', function () {
            var readMore = $(this);
            var div = $('<div style="overflow: hidden; display: none">');
            div.css('min-height', readMore.height() + 2);
            div.append(this.dataset.readMore);
            readMore.after(div);
            readMore.hide();
            div.slideDown();

            div.find('.read-less').on('click', function () {
                div.slideUp(400, function () {
                    readMore.show();
                    div.remove();
                });
                return false;
            });

            return false;
        });
        // endregion

        // region flights search results
        if ($('#filter_adults').length) { // check if search form exists on page before doing anything else

            $(document).on('click', '._btn_booking_details', function() {
                $('#' + $(this).attr('data-target')).modal();
            });

            $('#fs_booking_details').click(function() {
                $('#selected_option_modal').html($('#' + $(this).attr('data-target')).html()).modal();
            });

            $('#fs_booking_details_m').click(function() {
                $('#selected_option_modal_m').html($('#' + $(this).attr('data-target')).html()).modal();
            });

            var $et_tpl_container = $('#emission_tooltip_tpl_container');

            tippy.delegate('#flights-search-result-row', {
                target: '._sr_item_emission',
                theme: 'light',
                maxWidth: 320,
                boundary: 'viewport',
                placement: 'right-start',
                flipBehavior: ['right', 'top', 'bottom'],
                hideOnClick: false,
                ignoreAttributes: true,
                content: '',
                onShow: function(instance) {

                    var $ref = $(instance.reference);

                    $('#co2_emission_tooltip_val',     $et_tpl_container).text($ref.attr('data-co2'));
                    $('#co2_emission_tooltip_avg',     $et_tpl_container).text($ref.attr('data-co2-avg'));
                    $('#co2_emission_tooltip_savings', $et_tpl_container).text($ref.attr('data-co2-sv'));

                    $('#co2_emission_tooltip_delta',   $et_tpl_container)
                        .removeClass('_less_co2')
                        .removeClass('_more_co2')
                        .removeClass('_avg_co2')
                        .addClass($ref.attr('data-co2-class'))
                        .text($ref.attr('data-co2-delta'));

                    instance.setContent($et_tpl_container.html());
                }
            });

            tippy.delegate('#flights_search_result_cards_container', {
                target: '._it_more_co2',
                theme: 'light',
                maxWidth: 320,
                boundary: 'viewport',
                placement: 'right-start',
                flipBehavior: ['right', 'top', 'bottom'],
                hideOnClick: false,
                ignoreAttributes: true,
                content: window.siteData.tooltip_not_clean_enough
            });

            tippy.delegate('#flights-search-result-segment', {
                target: '._filter_tab_btn',
                theme: 'light',
                maxWidth: 320,
                boundary: 'viewport',
                placement: 'bottom-start',
                flipBehavior: ['right', 'top', 'bottom'],
                hideOnClick: false,
                ignoreAttributes: true,
                interactive: true,
                content: '',
                onShow: function(instance) {

                    var sort_by = $(instance.reference).attr('data-sort-by');
                    switch (sort_by) {
                        case 'qc':
                            instance.setContent(window.siteData.tooltip_qualified_choice);
                            break;
                        case 'cleanest':
                            instance.setContent(window.siteData.tooltip_cleanest);
                            break;
                        case 'fastest':
                            instance.setContent(window.siteData.tooltip_fastest);
                            break;
                        case 'cheapest':
                            instance.setContent(window.siteData.tooltip_cheapest);
                            break;
                    }
                }
            });

            tippy.delegate('#sr_page_container', {
                target: '._it_co2_info',
                theme: 'light',
                maxWidth: 320,
                boundary: 'viewport',
                placement: 'right-end',
                flipBehavior: ['right', 'top', 'bottom'],
                hideOnClick: false,
                ignoreAttributes: true,
                interactive: true,
                appendTo: document.body,
                content: window.siteData.tooltip_co2_info
            });

            var displayCheckout = function($btn) {

                $('body').addClass('checkout_bg');

                // scroll window to top
                window.scrollTo(0, 0);

                // show selection details
                var $segment                        = $('#flights-selected-option-segment');
                var $btn_book_selected_option       = $('#btn_book_selected_option',       $segment);
                var $btn_compensate_selected_option = $('#btn_compensate_selected_option', $segment);

                // checkout trip details modal
                $('#fs_booking_details', $segment).attr('data-target', $btn.attr('data-target'));

                $('#trip_from', $segment).text(
                    $btn.attr('data-from')
                    + ' '
                    + $btn.attr('data-city-from')
                    + ', '
                    + $btn.attr('data-country-from')
                );

                $('#trip_to', $segment).text(
                    $btn.attr('data-to')
                    + ' '
                    + $btn.attr('data-city-to')
                    + ', '
                    + $btn.attr('data-country-to')
                );

                $('#trip_dep_date', $segment).text($btn.attr('data-date-from'));
                $('#trip_ret_date', $segment).text($btn.attr('data-date-to'));

                if ($btn.attr('data-is-return') === '1') {
                    $('#trip_ret_date_container', $segment).show();
                } else {
                    $('#trip_ret_date_container', $segment).hide();
                }

                var adults   = parseInt($btn.attr('data-adults'))   || 0;
                var children = parseInt($btn.attr('data-children')) || 0;
                var infants  = parseInt($btn.attr('data-infants'))  || 0;
                var trip_passengers_text = adults + ' ' + ((adults > 1)? window.siteData.str_adults : window.siteData.str_adult);

                if (children) {
                    trip_passengers_text += ', ' + children + ' ' + ((children > 1)? window.siteData.str_children : window.siteData.str_child);
                }
                if (infants) {
                    trip_passengers_text += ', ' + infants + ' ' + ((infants > 1)? window.siteData.str_infants : window.siteData.str_infant);
                }

                trip_passengers_text += ', ' +  $btn.attr('data-cabins');
                $('#trip_passengers', $segment).text(trip_passengers_text);

                $btn_book_selected_option.attr('href', $btn.attr('data-deep-link'));

                $('._btn_val', $btn_book_selected_option).text($btn.attr('data-price'));
                $('._btn_val', $btn_compensate_selected_option).text($btn.attr('data-offset'));

                var atmosfair_url = 'https://co2offset.atmosfair.de/co2offset#/fix';
                    atmosfair_url += '?amount=' + Math.round($btn.attr('data-offset-val'));
                    atmosfair_url += '&locale=' + window.siteData.language;
                $btn_compensate_selected_option.attr('href', atmosfair_url);

                // $btn_compensate_selected_option.removeAttr('href').unbind().click(function(ev) {
                //     ev.preventDefault();
                //
                //     var atmosfair_url = 'https://co2offset.atmosfair.de/co2offset#/fix';
                //     atmosfair_url += '?amount=' + Math.round($btn.attr('data-offset-val'));
                //     atmosfair_url += '&locale=' + window.siteData.language;
                //
                //     window.openReqPopup(
                //         atmosfair_url,
                //         'Compensate on atmosfair.de'
                //     );
                // });

                var co2_rr_saved_val = parseFloat($btn.attr('data-co2-rr-saved-val')) || 0;
                if (co2_rr_saved_val > 0) {
                    $('#co2_reduction_val',            $segment).text($btn.attr('data-co2-rr-saved-str'));
                    $('#co2_reduction_light_bulb_str', $segment).text($btn.attr('data-co2-rr-light-str'));
                    $('#co2_reduction_washing_times',  $segment).text($btn.attr('data-co2-rr-washing-times'));
                    $('#co2_reduction_drive_km',       $segment).text($btn.attr('data-co2-rr-drive-km'));
                    $('#co2_reduction_relation',       $segment).show();
                } else {
                    $('#co2_reduction_relation', $segment).hide();
                }

                $('#your_offset_desc', $segment).html(
                    $('#your_offset_desc', $segment).attr('data-html').replace(
                        '%s',
                        $btn.attr('data-co2-total-str')
                    )
                );

                var provider_label = $('._search_provider', $btn_book_selected_option).attr('data-prefix');
                if ($btn.attr('data-provider') === 'kiwi') {
                    provider_label += 'Kiwi.com';
                }
                if ($btn.attr('data-provider') === 'fluege_de') {
                    provider_label += 'Fluege.de';
                }
                if ($btn.attr('data-provider') === 'etraveli') {
                    provider_label += $btn.attr('data-provider-bl');
                }
                if ($btn.attr('data-provider') === 'artefact') {
                    provider_label += $btn.attr('data-provider-bl');
                }
                $('._search_provider', $btn_book_selected_option).text(provider_label);

                $segment.show();
            };

            var displayMobileCheckout = function($btn) {

                // scroll window to top
                window.scrollTo(0, 0);

                // show selection details
                var $segment = $('#flights-selected-option-mobile-segment');
                var $btn_book_selected_option       = $('#btn_book_selected_option_m',       $segment);
                var $btn_floating_book_trip         = $('#btn_floating_book_trip',           $segment);
                var $btn_compensate_selected_option = $('#btn_compensate_selected_option_m', $segment);

                // checkout trip details card
                $('#ckm_trip_details > .modal-body', $segment).html($('#' + $btn.attr('data-target') + ' .modal-body').html());

                // checkout trip details modal
                $('#fs_booking_details_m', $segment).attr('data-target', $btn.attr('data-target'));

                $('#fs_checkout_header_dest').text($btn.attr('data-city-to'));

                var toggleFloatingBookBtn = function() {
                    if (
                           $('._checkout_section ._card_trip',   $segment).hasClass('_card_exp')
                        || $('._checkout_section ._card_offset', $segment).hasClass('_card_exp')
                    ) {
                        $btn_floating_book_trip.fadeOut();
                    } else {
                        $btn_floating_book_trip.fadeIn();
                    }
                };

                $('._checkout_section ._card', $segment).each(function() {
                    var $card = $(this);

                    // default state is collapsed
                    $card.removeClass('_card_exp');
                    $('._body', $card).stop().slideUp(0);

                    $('._header', $card).unbind().click(function() {

                        $card.toggleClass('_card_exp');
                        toggleFloatingBookBtn();

                        if ($card.hasClass('_card_exp')) {
                            $('._body', $card).stop().slideDown(400);

                            // scroll to top
                            $("html, body").animate({
                                scrollTop: $card.parent().offset().top
                            }, 400);

                        } else {
                            $('._body', $card).stop().slideUp(400);
                        }
                    });
                });

                toggleFloatingBookBtn();

                var co2_rr_saved_val = parseFloat($btn.attr('data-co2-rr-saved-val')) || 0;
                if (co2_rr_saved_val > 0) {
                    $('#co2_reduction_val_m',            $segment).text($btn.attr('data-co2-rr-saved-str'));
                    $('#co2_reduction_light_bulb_str_m', $segment).text($btn.attr('data-co2-rr-light-str'));
                    $('#co2_reduction_washing_times_m',  $segment).text($btn.attr('data-co2-rr-washing-times'));
                    $('#co2_reduction_drive_km_m',       $segment).text($btn.attr('data-co2-rr-drive-km'));

                    var $card_savings_title = $('._card_savings > ._header > ._card_title', $segment);
                    $card_savings_title.html(
                        $card_savings_title.attr('data-html').replace(
                            '%s',
                            $btn.attr('data-co2-avg-str')
                        )
                    );

                } else {
                    $('._card_savings', $segment).removeClass('_card_exp');
                    $('._card_savings > ._header > ._toggle_ind', $segment).hide();
                    $('._card_savings > ._body', $segment).stop().slideUp(400);
                }


                $('#ckm_dest_fr').text($btn.attr('data-city-from'));
                $('#ckm_dest_to').text($btn.attr('data-city-to'));

                var $card_offset_title = $('._card_offset > ._header > ._card_title', $segment);
                $card_offset_title.html(
                    $card_offset_title.attr('data-html').replace(
                        '%s',
                        $btn.attr('data-offset')
                    )
                );

                $('#your_offset_desc_m', $segment).html(
                    $('#your_offset_desc_m', $segment).attr('data-html').replace(
                        '%s',
                        $btn.attr('data-co2-total-str')
                    )
                );

                $('#trip_from_m', $segment).text(
                    $btn.attr('data-from')
                    + ' '
                    + $btn.attr('data-city-from')
                    + ', '
                    + $btn.attr('data-country-from')
                );

                $('#trip_to_m', $segment).text(
                    $btn.attr('data-to')
                    + ' '
                    + $btn.attr('data-city-to')
                    + ', '
                    + $btn.attr('data-country-to')
                );

                $('#trip_dep_date_m', $segment).text($btn.attr('data-date-from'));
                $('#trip_ret_date_m', $segment).text($btn.attr('data-date-to'));

                if ($btn.attr('data-is-return') === '1') {
                    $('#trip_ret_date_container_m', $segment).show();
                } else {
                    $('#trip_ret_date_container_m', $segment).hide();
                }

                var adults   = parseInt($btn.attr('data-adults'))   || 0;
                var children = parseInt($btn.attr('data-children')) || 0;
                var infants  = parseInt($btn.attr('data-infants'))  || 0;
                var trip_passengers_text = adults + ' ' + ((adults > 1)? window.siteData.str_adults : window.siteData.str_adult);

                if (children) {
                    trip_passengers_text += ', ' + children + ' ' + ((children > 1)? window.siteData.str_children : window.siteData.str_child);
                }
                if (infants) {
                    trip_passengers_text += ', ' + infants + ' ' + ((infants > 1)? window.siteData.str_infants : window.siteData.str_infant);
                }

                trip_passengers_text += ', ' +  $btn.attr('data-cabins');
                $('#trip_passengers_m', $segment).text(trip_passengers_text);

                var deep_link = $btn.attr('data-deep-link-mobile');
                if (!deep_link.length) {
                    deep_link = $btn.attr('data-deep-link');
                }

                $btn_book_selected_option.attr('href', deep_link);
                $btn_book_selected_option.unbind().click(function() {
                    // expand offset card
                    $('._checkout_section ._card_offset > ._header', $segment).removeClass('_card_exp').click();
                });

                $btn_floating_book_trip.attr('href', deep_link);
                $btn_floating_book_trip.unbind().click(function() {
                    // expand offset card
                    $('._checkout_section ._card_offset > ._header', $segment).removeClass('_card_exp').click();
                });

                $('._btn_val', $btn_book_selected_option).text($btn.attr('data-price'));
                $('._btn_val', $btn_compensate_selected_option).text($btn.attr('data-offset'));

                var atmosfair_url = 'https://co2offset.atmosfair.de/co2offset#/fix';
                    atmosfair_url += '?amount=' + Math.round($btn.attr('data-offset-val'));
                    atmosfair_url += '&locale=' + window.siteData.language;
                $btn_compensate_selected_option.attr('href', atmosfair_url);

                var provider_label = $('._search_provider', $btn_book_selected_option).attr('data-prefix');
                if ($btn.attr('data-provider') === 'kiwi') {
                    provider_label += 'Kiwi.com';
                }
                if ($btn.attr('data-provider') === 'fluege_de') {
                    provider_label += 'Fluege.de';
                }
                if ($btn.attr('data-provider') === 'etraveli') {
                    provider_label += $btn.attr('data-provider-bl');
                }
                if ($btn.attr('data-provider') === 'artefact') {
                    provider_label += $btn.attr('data-provider-bl');
                }
                $('._search_provider', $btn_book_selected_option).text(provider_label);

                $segment.show();
            };

            $(document).on('click', '._btn_itinerary_booking_options', function() {

                var $btn = $(this);

                if ($btn.attr('href')) {
                    return true;
                }

                // block checkout page if CO2 > avg
                if ($btn.hasClass('_it_more_co2')) {
                    return false;
                }

                // save window scroll position
                window.flights_results_scroll_y = window.scrollY;

                // hide mobile search form toolbar
                var $search_form_toolbar = $('#search_form_toolbar');
                if ($search_form_toolbar.length) {
                    $search_form_toolbar.addClass('search-form-toolbar-checkout-hidden');
                }

                // hide booking form and flight results
                $('#header_booking_form_block').addClass('_search_form_hidden');
                $('#flights-search-result-segment').hide();

                if (window.innerWidth < 1140) {
                    displayMobileCheckout($btn); // mobile/tablet
                } else {
                    displayCheckout($btn); // desktop
                }

                window.location.hash = $btn.attr('data-id');
            });

            $(document).on('click', '.btn_return_to_results', function() {
                $('#flights-selected-option-mobile-segment').hide();
                $('#flights-selected-option-segment').hide();
                $('body').removeClass('checkout_bg');

                $('#header_booking_form_block').removeClass('_search_form_hidden');
                $('#flights-search-result-segment').show();

                // restore mobile search form toolbar
                var $search_form_toolbar = $('#search_form_toolbar');
                if ($search_form_toolbar.length) {
                    $search_form_toolbar.removeClass('search-form-toolbar-checkout-hidden');
                }

                // restore previous scroll position
                if (typeof window.flights_results_scroll_y !== 'undefined') {
                    window.scrollTo(0, window.flights_results_scroll_y);
                }

                window.location.hash = '';
            });

            $(document).on('click', '#flights_search_result_sort_tabs_container ._filter_tab_btn', function(e) {
                var sort_by = $(this).attr('data-sort-by');
                if (!sort_by) return false;

                var sort_dir = $(this).attr('data-sort-dir');
                if (!sort_dir) return false;

                e.preventDefault();
                window.updateFlightsSearchResults(false, sort_by, sort_dir);
            });

            $(document).on('change', '#filter_sort_dir', function(e) {
                var $af = $('#flights_search_result_sort_tabs_container ._filter_tab_btn.active');

                var sort_by = $af.attr('data-sort-by');
                if (!sort_by) return false;

                var sort_dir = $(this).val();

                e.preventDefault();
                window.updateFlightsSearchResults(false, sort_by, sort_dir);
            });

            $(document).on('click', '#flights_search_pagination .page-item:not(".disabled") .page-link', function(e) {

                var page = parseInt($(this).attr('data-page')) || 0;
                if (!page) return false;

                e.preventDefault();
                window.updateFlightsSearchResults(true, null, null, page);
            });

        }
        // endregion

        // region share btn copy to clipboard
        $('.flights_selected_option_share_btn').each(function() {
            var $so_share_btn = $(this);
            $so_share_btn.tooltip({
                trigger: 'click',
                placement: 'bottom'
            });

            var ss_clipboard = new ClipboardJS($so_share_btn[0]);
            ss_clipboard.on('success', function () {

                $so_share_btn
                    .tooltip('hide')
                    .tooltip('show');

                setTimeout(function () {
                    $so_share_btn.tooltip('hide');
                }, 1000);

            });
        });
        // endregion

        // region ambassador slider block
        $('.ambassador-slider-block').each(function() {
            var $blk           = $(this);
            var $container     = $('._items_container', $blk);
            //var scroll_timeout = null;

            // $('._btn_scroll_right', $blk).on('touchstart mousedown', function(e) {
            //     e.stopPropagation();
            //     e.preventDefault();
            //
            //     (function scrollContainerLeft() {
            //
            //         var scroll_width = $('._container', $blk).width();
            //         var pos_left = $container.position().left;
            //         if (-pos_left >= $container.width() - scroll_width) {
            //             $container.stop();
            //             clearTimeout(scroll_timeout);
            //             return false;
            //         }
            //
            //         $container.stop().animate({
            //             left: pos_left - 30
            //         }, 50, 'linear', function() {
            //             scroll_timeout = setTimeout(scrollContainerLeft(), 0);
            //         });
            //
            //     })();
            //
            // }).on('touchend touchcancel mouseup mouseout', function(e) {
            //     e.stopPropagation();
            //     e.preventDefault();
            //
            //     $container.stop();
            //     clearTimeout(scroll_timeout);
            // });

            $('._btn_scroll_right', $blk).on('click', function() {

                var scroll_width = $('._container', $blk).width();
                var pos_left = $container.position().left - 360;
                if (pos_left < -($container.width() - scroll_width) + 100) {
                    pos_left = -($container.width() - scroll_width);
                }

                $container.stop().animate({
                    left: pos_left
                }, 400, 'swing');
            });

            $('._btn_scroll_left', $blk).on('click', function() {

                var pos_left = $container.position().left + 360;
                if (pos_left > -100) {
                    pos_left = 0;
                }

                $container.stop().animate({
                    left: pos_left
                }, 400, 'swing');
            });

            // $('._btn_scroll_left', $blk).on('touchstart mousedown', function(e) {
            //     e.stopPropagation();
            //     e.preventDefault();
            //
            //     (function scrollContainerRight() {
            //
            //         var pos_left = $container.position().left;
            //         if (pos_left >= 0) {
            //             $container.stop();
            //             clearTimeout(scroll_timeout);
            //             return false;
            //         }
            //
            //         $container.stop().animate({
            //             left: pos_left + 30
            //         }, 50, 'linear', function() {
            //             scroll_timeout = setTimeout(scrollContainerRight(), 0);
            //         });
            //
            //     })();
            //
            // }).on('touchend touchcancel mouseup mouseout', function(e) {
            //     e.stopPropagation();
            //     e.preventDefault();
            //
            //     $container.stop();
            //     clearTimeout(scroll_timeout);
            // });

        });
        // endregion

        // general tippy.js tooltips
        tippy('[data-tippy-content]', {theme: 'light'});

        // region compare flights
        if ($('#compare_flight_categories').length) {
            $('#compare_flight_categories .compare_flight_flight').click(function() {

                var fly_from = $(this).attr('data-from');
                var fly_to   = $(this).attr('data-to');

                $('#filter_fly_from')
                    .empty()
                    .append('<option value="' + fly_from + '">' + fly_from + '</option>')
                    .val(fly_from)
                    .trigger('change');

                $('#filter_fly_to')
                    .empty()
                    .append('<option value="' + fly_to + '">' + fly_to + '</option>')
                    .val(fly_to)
                    .trigger('change');

                $('#flights_date_fr_dmy').data('daterangepicker').show();
                $("html, body").animate({ scrollTop: 0 }, "slow");

            });
        }
        // endregion

        // region trending destinations
        $('.trending-destinations-block').each(function() {
            var $blk = $(this);
            $('._dst', $blk).each(function() {
                if ($(this).hasClass('_dst_ad')) {
                    return true; // continue
                }

                $('._dc_button', this).click(function() {
                    var airport_from = $(this).attr('data-a-fr');
                    var airport_to   = $(this).attr('data-a-to');
                    var date_from    = $(this).attr('data-d-fr');
                    var date_to      = $(this).attr('data-d-to');

                    $('#header_search_form_flight_type').val('round').change();
                    $('#filter_adults').val(0);
                    $('#filter_children').val(0);
                    $('#filter_infants').val(0);
                    $('#filter_btn_add_adults').click();
                    $('#header_search_form_selected_cabins').val('M');

                    $('#filter_fly_from')
                        .empty()
                        .append('<option value="' + airport_from + '">' + airport_from + '</option>')
                        .val(airport_from)
                        .trigger('change');

                    $('#filter_fly_to')
                        .empty()
                        .append('<option value="' + airport_to + '">' + airport_to + '</option>')
                        .val(airport_to)
                        .trigger('change');

                    $('#flights_date_fr_dmy').val(date_from);
                    $('#flights_date_to_dmy').val(date_to);

                    $("html, body").animate({ scrollTop: 0 }, "slow");
                    $('#header_search_form').submit();
                });
            });
        });
        // endregion


        // region post share btn copy to clipboard
        $('.post_share_btn').each(function() {

            var $btn = $(this);

            $btn.tooltip({
                trigger: 'click',
                placement: 'bottom'
            });

            var ss_clipboard = new ClipboardJS($btn[0]);
            ss_clipboard.on('success', function () {

                $btn
                    .tooltip('hide')
                    .tooltip('show');

                setTimeout(function () {
                    $btn.tooltip('hide');
                }, 1000);

            });
        });
        // endregion

        // region newsletter
        (function() {
            var $modal = $('#newsletter_popup_modal');
            if ($modal.length) {
                var remember_sel = $modal.attr('data-remember-sel') === '1';
                if (remember_sel) {
                    if (Cookies.get('newsletter_popup_shown') === '1') {
                        return false;
                    }
                    $modal.on('hide.bs.modal', function () {
                        Cookies.set('newsletter_popup_shown', '1', {expires: 1});
                    });
                }

                $('.btn-success', $modal).click(function () {

                    $('._np_header', $modal).hide();
                    $('._np_action', $modal).hide();
                    $('._np_footer', $modal).hide();

                    $('.modal-dialog', $modal).addClass('modal-lg');

                    $('.modal-content', $modal)
                        .append('<iframe src="' + $(this).attr('data-iframe-url') + '" height="'
                            + $(this).attr('data-iframe-height') + '" width="100%"></iframe>');
                });

                var popup_delay = parseInt($modal.attr('data-delay')) || 0;
                if (popup_delay) {
                    setTimeout(function() {
                        $modal.modal();
                    }, popup_delay * 1000);
                } else {
                    $modal.modal();
                }
            }

        })();
        // endregion

        // region search results browser history navigation
        if ($('#sr_page_container').length) { // check if we're on the search results page
            window.onhashchange = function() { // listen to browser hash change
                var $item = $(location.hash);
                if ($item.length) { // check if search results item exists
                    // check if we are already on the checkout page
                    if (!$('#flights-selected-option-segment:visible').length) {
                        $('._btn_itinerary_booking_options', $item).click();
                    }
                } else {
                    $('.btn_return_to_results').first().click();
                }
            };
        }
        // endregion

    }); // end document.ready

})(jQuery);

window.openReqPopup = function(url, name, width, height) {

    if (name === undefined) {
        name = "";
    }

    var windowFeatures = "location=yes,resizable=yes,scrollbars=yes,status=yes";
    if (width) {
        windowFeatures += ",width=" + width;
    }
    if (height) {
        windowFeatures += ",height=" + height;
    }
    var newWindow = window.open(url, name, windowFeatures);

    if (window.focus) {
        newWindow.focus()
    }
}
